import { assessmentResultModelModule } from '../../../../shared/app/models/assessment-result';

export const assessmentResultsServiceModule = angular
  .module('Q.services.assessment-results-service', [
    assessmentResultModelModule,
  ])

  .factory(
    'assessmentResultsService',
    function (AssessmentResult, $q, $timeout) {
      const defaultIncludes = [
        'assessment',
        'challenge_items.challenge',
        'solutions',
        'team_candidate',
        'signals_profile',
      ];

      return {
        start,
        find,
        submit,
        update,
      };

      function update(instance, updates = {}) {
        const { candidateRemarks, closedReason } = instance;
        return AssessmentResult.update(
          instance,
          angular.extend({ candidateRemarks, closedReason }, updates),
        );
      }

      function start(assessmentId) {
        let a = AssessmentResult.get(assessmentId);
        let shouldStart = !a || a.isOpened() || a.isInvited();
        return shouldStart ? AssessmentResult.start(assessmentId) : $q.when(a);
      }

      function find(assessmentId, candidateId) {
        return AssessmentResult.fetchAll(
          { assessmentId, candidateId },
          {
            params: {
              includes: defaultIncludes,
            },
          },
        ).then(function (assessmentApps) {
          return assessmentApps[0];
        });
      }

      function submit(instance) {
        if (instance.isClosed()) {
          return $q.when(instance);
        } else {
          return update(instance)
            .then(() => AssessmentResult.submit(instance))
            .catch((resp) => {
              if (
                resp.status === 403 &&
                resp.data &&
                /pending solution/i.test(resp.data.reason)
              ) {
                // try a second time after 15 seconds for pending solutions
                return $timeout(() => AssessmentResult.submit(instance), 15000);
              } else {
                return $q.reject(resp);
              }
            });
        }
      }
    },
  );
